module.exports = "/images/win-the-home.png?1b8e3eb122e2015b02ffb74b93bffccf";